export default __webpack_public_path__ + "static/media/i-sem-acesso.3ad53de4.png";